module.exports = __webpack_public_path__ + "img/elasticbitcoin-HOLDINGS-RISE-WITH-MARKET-CAP.70405312.svg";